module.exports = ".block_groups_blacklist{\n\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/admin/icontact/setting/contact/blacklist/blacklist.component.css
// module id = ./src/app/pages/admin/icontact/setting/contact/blacklist/blacklist.component.css
// module chunks = main